import React from 'react';
import { Autocomplete, TextField, Chip, Checkbox } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const SearchableMultiSelect = ({
  label,
  options,
  value,
  onChange,
  error,
  helperText,
  required,
  getOptionLabel,
  isOptionEqualToValue,
  chipColor,
  placeholder,
  hideTags = false,
  showPlaceholderAlways = false,
  ...autocompleteProps
}) => {
  const safeValue = Array.isArray(value) ? value : [];

  return (
    <Autocomplete
      multiple
      options={options}
      value={safeValue}
      onChange={(event, newValue) => {
        onChange({ target: { value: newValue } });
      }}
      // let MUI manage input so typed text persists
      getOptionLabel={getOptionLabel || ((option) => option)}
      isOptionEqualToValue={isOptionEqualToValue || ((option, v) => option === v)}
      disableCloseOnSelect
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            checked={selected}
            sx={{ '&.Mui-checked': { color: chipColor || '#29C0BB' } }}
          />
          {getOptionLabel ? getOptionLabel(option) : option}
        </li>
      )}
      renderTags={
        hideTags
          ? () => null
          : (tagValue, getTagProps) => {
              // Extra safety check for tagValue
              const safeTags = Array.isArray(tagValue) ? tagValue : [];
              return safeTags.map((option, index) => (
                <Chip
                  {...getTagProps({ index })}
                  key={index}
                  label={getOptionLabel ? getOptionLabel(option) : option}
                  size="small"
                  onDelete={() => {
                    const newValue = safeValue.filter((_, i) => i !== index);
                    onChange({ target: { value: newValue } });
                  }}
                  deleteIcon={<CloseIcon />}
                  sx={{
                    backgroundColor: chipColor || '#29C0BB',
                    color: 'white',
                    '& .MuiChip-deleteIcon': {
                      color: 'white',
                      '&:hover': { color: '#f5f5f5' }
                    }
                  }}
                />
              ));
            }
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={showPlaceholderAlways ? placeholder : (safeValue.length > 0 ? '' : placeholder)}
          error={error}
          helperText={helperText}
          required={required}
          InputLabelProps={{ shrink: true }}
        />
      )}
      ListboxProps={{ style: { maxHeight: 250 } }}
      sx={{
        '& .MuiAutocomplete-inputRoot': { paddingTop: '16.5px', paddingBottom: '16.5px' },
        '& .MuiAutocomplete-input': { padding: '0 !important' },
        ...(hideTags ? { '& .MuiAutocomplete-tag': { display: 'none' } } : {})
      }}
      {...autocompleteProps}
    />
  );
};

export default SearchableMultiSelect;